import React, { useState, useEffect, useMemo } from 'react';
import { baseUrl } from '../components/BaseUrl';
import { Link } from 'react-router-dom';
import TopBar  from '../components/Topbar';
import { MyProSidebarProvider } from "../components/SidebarContext";
import Footer  from '../components/Footer';
import '../App.css';
import axios from 'axios';
import Swal from "sweetalert2";
import GreetUser  from '../components/GreetUser';
import AOS from 'aos';
import 'aos/dist/aos.css';
AOS.init();

const Video = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [availabilityFilter, setAvailabilityFilter] = useState('all'); // 'all', 'available', 'coming-soon'
  const [categoryFilter, setCategoryFilter] = useState('all');
  const [levelFilter, setLevelFilter] = useState('all');

  useEffect(() => {
    fetchCourses();
  }, []);

  const fetchCourses = async () => {
  const token = localStorage.getItem("codefussion-login-token");
  setLoading(true);
  axios.get(`${baseUrl}get-videos.php`, {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: token
    }
  })
  .then(response => {
    // console.log("API Response:", response.data); // Add this to debug
    // console.log("First video data:", response.data[0]); // Check first item
    setData(response.data);
    setLoading(false);
  })
  .catch((error) => {
    // console.error("API Error:", error); // Add error logging
    Swal.fire({
      title: "Error",
      text: "An error occurred. Please try again later",
      icon: "error",
      confirmButtonText: "OK",
      backdrop: `rgba(143, 70, 0, 0.3) left top no-repeat`
    });
    setLoading(false);
  });
}

  // Get unique categories and levels for filters
  const categories = useMemo(() => {
    const uniqueCategories = [...new Set(data.map(item => item.category))].filter(Boolean);
    return uniqueCategories.sort();
  }, [data]);

  const levels = useMemo(() => {
    const uniqueLevels = [...new Set(data.map(item => item.level))].filter(Boolean);
    return uniqueLevels.sort();
  }, [data]);

  // Real-time filtering
  const filteredVideos = useMemo(() => {
    let filtered = data;

    // Search filter
    if (searchTerm) {
      filtered = filtered.filter(video => 
        video.video_title?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        video.video_description?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        video.keyword_one?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        video.keyword_two?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        video.keyword_three?.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    // Availability filter
    if (availabilityFilter === 'available') {
      filtered = filtered.filter(video => video.available === "true" || video.available === true);
    } else if (availabilityFilter === 'coming-soon') {
      filtered = filtered.filter(video => !(video.available === "true" || video.available === true));
    }

    // Category filter
    if (categoryFilter !== 'all') {
      filtered = filtered.filter(video => video.category === categoryFilter);
    }

    // Level filter
    if (levelFilter !== 'all') {
      filtered = filtered.filter(video => video.level === levelFilter);
    }

    return filtered;
  }, [data, searchTerm, availabilityFilter, categoryFilter, levelFilter]);

  const showCourses = () => {
    try {
      if (filteredVideos.length === 0) {
        return (
          <div className="col-12 text-center py-5">
            <div className="no-videos">
              <i className="fas fa-video-slash fa-3x text-muted mb-3"></i>
              <h4>No videos found</h4>
              <p className="text-muted">
                {searchTerm 
                  ? `No videos match "${searchTerm}". Try a different search term.`
                  : "No videos match your selected filters. Try changing your filter options."}
              </p>
              {(searchTerm || availabilityFilter !== 'all' || categoryFilter !== 'all' || levelFilter !== 'all') && (
                <button 
                  className="btn btn-primary mt-2"
                  onClick={() => {
                    setSearchTerm('');
                    setAvailabilityFilter('all');
                    setCategoryFilter('all');
                    setLevelFilter('all');
                  }}
                >
                  Clear All Filters
                </button>
              )}
            </div>
          </div>
        );
      }

      return filteredVideos.map((item, index) => {
        const isAvailable = item.available === "true" || item.available === true;
        let shortenString = item.video_description?.substring(0, 36).concat('...') || 'No description available';
        
        return(
          <div data-aos="fade-up" data-aos-duration="1000" className="col-md-4 col-sm-6 item" key={item.id}>
            <div className={`card card-body mb-4 card-block video-card ${!isAvailable ? 'video-unavailable' : ''}`}>
              
              {/* Availability Badge */}
              {!isAvailable && (
                <div className="unavailable-badge">
                  COMING SOON
                </div>
              )}
              
              {/* Free Badge */}
              {isAvailable && (
                <div className="free-badge">
                  FREE
                </div>
              )}
              
              <img src={`${baseUrl}${item.image}`} alt={item.video_title} className="img-fluid video-thumbnail" />
              
              <div className="video-info">
                <h3 className="card-title mt-2">{item.video_title}</h3>
                <p className="card-text">{shortenString}</p>
                
                <div className="video-meta">
                  <span className="level-badge">{item.level}</span>
                  <span className="category-tag">{item.category}</span>
                </div>
                
                <div className="video-details">
                  <span className="duration">{item.duration}</span>
                  {item.rating && <span className="rating">⭐ {item.rating}</span>}
                </div>
              </div>
              
              <Link to={`/watch-video/${item.video_id}`}>
                <button 
                  className={`learn-btn ${!isAvailable ? 'btn-disabled' : ''}`} 
                  type="button"
                  disabled={!isAvailable}
                >
                  {isAvailable ? 'Watch Now' : 'Coming Soon'}
                </button>
              </Link>
            </div>
          </div>
        );
      });
    } catch(e) {
      return(
        <div className="col-12">
          <p className="text-danger">An error occurred. That's all we know.</p>
        </div>
      );
    }
  }

  // Get counts for filters
  const getVideoCounts = () => {
    const available = data.filter(video => video.available === "true" || video.available === true).length;
    const comingSoon = data.filter(video => !(video.available === "true" || video.available === true)).length;
    
    return { total: data.length, available, comingSoon };
  }

  const videoCounts = getVideoCounts();

  return (
    <MyProSidebarProvider>
      {localStorage.getItem("codefussion-login-token") === null ? window.location.replace("/login") :
      <div className="row">
        <div>
          <TopBar />
        </div>
        <div className="col-md-12">
          {loading ? (
            <div style={{marginLeft: 180, position: 'relative', top: -144 }}>
              <div className="loader-wrapper" id="loading">
                <div className="loader">
                  <div className="loader loader-inner"></div>
                </div>
              </div>
            </div>
          ) : (
            <div className="videos-container">
              <h2 className="text-dark mt-4 mb-2 font-weight-bold">Watch Videos</h2>
              
              {/* Search Bar */}
              <div className="search-container mb-4">
                <div className="search-box">
                  <i className="fas fa-search search-icon"></i>
                  <input
                    type="text"
                    placeholder="Search videos by title, description, or keywords..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="search-input"
                  />
                  {searchTerm && (
                    <button 
                      className="clear-search"
                      onClick={() => setSearchTerm('')}
                    >
                      <i className="fas fa-times"></i>
                    </button>
                  )}
                </div>
              </div>
              
              {/* Filter Section */}
              <div className="filter-section mb-4">
                <div className="filter-tabs">
                  <button 
                    className={`filter-btn ${availabilityFilter === 'all' ? 'active' : ''}`}
                    onClick={() => setAvailabilityFilter('all')}
                  >
                    All Videos
                    <span className="count-badge">{videoCounts.total}</span>
                  </button>
                  <button 
                    className={`filter-btn ${availabilityFilter === 'available' ? 'active' : ''}`}
                    onClick={() => setAvailabilityFilter('available')}
                  >
                    Available Now
                    <span className="count-badge available-count">{videoCounts.available}</span>
                  </button>
                  <button 
                    className={`filter-btn ${availabilityFilter === 'coming-soon' ? 'active' : ''}`}
                    onClick={() => setAvailabilityFilter('coming-soon')}
                  >
                    Coming Soon
                    <span className="count-badge coming-soon-count">{videoCounts.comingSoon}</span>
                  </button>
                </div>

                {/* Category and Level Filters */}
                <div className="dropdown-filters">
                  <div className="filter-dropdown">
                    <label>Category:</label>
                    <select 
                      value={categoryFilter} 
                      onChange={(e) => setCategoryFilter(e.target.value)}
                      className="filter-select"
                    >
                      <option value="all">All Categories</option>
                      {categories.map(category => (
                        <option key={category} value={category}>{category}</option>
                      ))}
                    </select>
                  </div>

                  <div className="filter-dropdown">
                    <label>Level:</label>
                    <select 
                      value={levelFilter} 
                      onChange={(e) => setLevelFilter(e.target.value)}
                      className="filter-select"
                    >
                      <option value="all">All Levels</option>
                      {levels.map(level => (
                        <option key={level} value={level}>{level}</option>
                      ))}
                    </select>
                  </div>
                </div>

                {/* Active Filters Display */}
                {(searchTerm || availabilityFilter !== 'all' || categoryFilter !== 'all' || levelFilter !== 'all') && (
                  <div className="active-filters">
                    <span className="active-filters-label">Active filters:</span>
                    {searchTerm && (
                      <span className="filter-chip">
                        Search: "{searchTerm}"
                        <button onClick={() => setSearchTerm('')}>×</button>
                      </span>
                    )}
                    {availabilityFilter !== 'all' && (
                      <span className="filter-chip">
                        {availabilityFilter === 'available' && 'Available Now'}
                        {availabilityFilter === 'coming-soon' && 'Coming Soon'}
                        <button onClick={() => setAvailabilityFilter('all')}>×</button>
                      </span>
                    )}
                    {categoryFilter !== 'all' && (
                      <span className="filter-chip">
                        Category: {categoryFilter}
                        <button onClick={() => setCategoryFilter('all')}>×</button>
                      </span>
                    )}
                    {levelFilter !== 'all' && (
                      <span className="filter-chip">
                        Level: {levelFilter}
                        <button onClick={() => setLevelFilter('all')}>×</button>
                      </span>
                    )}
                    <button 
                      className="clear-all-filters"
                      onClick={() => {
                        setSearchTerm('');
                        setAvailabilityFilter('all');
                        setCategoryFilter('all');
                        setLevelFilter('all');
                      }}
                    >
                      Clear All
                    </button>
                  </div>
                )}
              </div>

              {/* Results Count */}
              <div className="results-count mb-3">
                <strong>{filteredVideos.length}</strong> 
                {filteredVideos.length === 1 ? ' video' : ' videos'} 
                {searchTerm && ` matching "${searchTerm}"`}
              </div>
              
              <div className="col-md-12">
                <div className="row row-cols-1 row-cols-md-2 p-3">
                  {showCourses()}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      }

      <style jsx>{`
        .videos-container {
          padding: 0 1rem;
        }

        /* Search Bar Styles */
        .search-container {
          max-width: 600px;
        }

        .search-box {
          position: relative;
          display: flex;
          align-items: center;
        }

        .search-icon {
          position: absolute;
          left: 15px;
          color: #6c757d;
          z-index: 2;
        }

        .search-input {
          width: 100%;
          padding: 12px 45px 12px 45px;
          border: 2px solid #e0e0e0;
          border-radius: 25px;
          font-size: 1rem;
          transition: all 0.3s ease;
          background: white;
        }

        .search-input:focus {
          outline: none;
          border-color: #0066ff;
          box-shadow: 0 0 0 3px rgba(0, 102, 255, 0.1);
        }

        .clear-search {
          position: absolute;
          right: 15px;
          background: none;
          border: none;
          color: #6c757d;
          cursor: pointer;
          padding: 5px;
          border-radius: 50%;
          transition: all 0.2s ease;
        }

        .clear-search:hover {
          background: #f8f9fa;
          color: #495057;
        }

        /* Filter Section */
        .filter-section {
          border-bottom: 1px solid #e0e0e0;
          padding-bottom: 1rem;
        }

        .filter-tabs {
          display: flex;
          gap: 10px;
          flex-wrap: wrap;
          margin-bottom: 1rem;
        }

        .filter-btn {
          position: relative;
          padding: 10px 20px;
          border: 2px solid #e0e0e0;
          background: white;
          color: #495057;
          border-radius: 25px;
          font-weight: 600;
          cursor: pointer;
          transition: all 0.3s ease;
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .filter-btn:hover {
          border-color: #0066ff;
          color: #0066ff;
          transform: translateY(-2px);
        }

        .filter-btn.active {
          background: #0066ff;
          border-color: #0066ff;
          color: white;
        }

        .count-badge {
          background: rgba(0, 0, 0, 0.1);
          color: inherit;
          padding: 2px 8px;
          border-radius: 12px;
          font-size: 0.8rem;
          font-weight: 600;
        }

        .filter-btn.active .count-badge {
          background: rgba(255, 255, 255, 0.3);
        }

        .available-count {
          background: rgba(0, 204, 136, 0.2);
          color: #008055;
        }

        .coming-soon-count {
          background: rgba(108, 117, 125, 0.2);
          color: #495057;
        }

        /* Dropdown Filters */
        .dropdown-filters {
          display: flex;
          gap: 20px;
          flex-wrap: wrap;
          margin-bottom: 1rem;
        }

        .filter-dropdown {
          display: flex;
          flex-direction: column;
          gap: 5px;
        }

        .filter-dropdown label {
          font-weight: 600;
          color: #495057;
          font-size: 0.9rem;
        }

        .filter-select {
          padding: 8px 12px;
          border: 2px solid #e0e0e0;
          border-radius: 8px;
          background: white;
          cursor: pointer;
          transition: border-color 0.3s ease;
        }

        .filter-select:focus {
          outline: none;
          border-color: #0066ff;
        }

        /* Active Filters */
        .active-filters {
          display: flex;
          align-items: center;
          gap: 10px;
          flex-wrap: wrap;
        }

        .active-filters-label {
          font-weight: 600;
          color: #495057;
        }

        .filter-chip {
          display: flex;
          align-items: center;
          gap: 5px;
          background: #e9ecef;
          padding: 5px 12px;
          border-radius: 20px;
          font-size: 0.9rem;
        }

        .filter-chip button {
          background: none;
          border: none;
          cursor: pointer;
          padding: 2px;
          border-radius: 50%;
          width: 20px;
          height: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: background 0.2s ease;
        }

        .filter-chip button:hover {
          background: #dee2e6;
        }

        .clear-all-filters {
          background: none;
          border: none;
          color: #0066ff;
          cursor: pointer;
          font-weight: 600;
          padding: 5px 10px;
          border-radius: 4px;
          transition: background 0.2s ease;
        }

        .clear-all-filters:hover {
          background: #f8f9fa;
        }

        /* Results Count */
        .results-count {
          color: #6c757d;
          font-size: 0.9rem;
        }

        .results-count strong {
          color: #0066ff;
        }

        /* Video Card Styles */
        .video-card {
          position: relative;
          overflow: hidden;
          transition: all 0.3s ease;
          border: 1px solid #e0e0e0;
        }

        .video-unavailable {
          opacity: 0.7;
          background-color: #f8f9fa;
        }

        .video-unavailable:hover {
          transform: none;
          box-shadow: 0 2px 10px rgba(0,0,0,0.1);
        }

        .video-thumbnail {
          height: 200px;
          object-fit: cover;
          width: 100%;
          border-radius: 8px 8px 0 0;
        }

        .video-info {
          padding: 1rem;
        }

        .video-meta {
          display: flex;
          gap: 8px;
          margin-bottom: 0.5rem;
          flex-wrap: wrap;
        }

        .level-badge {
          background: #f0f7ff;
          color: #0066ff;
          padding: 4px 8px;
          border-radius: 12px;
          font-size: 0.8rem;
          font-weight: 600;
        }

        .category-tag {
          background: #f8f9fa;
          color: #495057;
          padding: 4px 8px;
          border-radius: 12px;
          font-size: 0.8rem;
        }

        .video-details {
          display: flex;
          justify-content: space-between;
          font-size: 0.9rem;
          color: #666;
          margin-bottom: 1rem;
        }

        /* Badge Styles */
        .unavailable-badge {
          position: absolute;
          top: 12px;
          right: 12px;
          background: linear-gradient(135deg, #6c757d, #495057);
          color: white;
          padding: 8px 16px;
          border-radius: 20px;
          font-size: 0.75rem;
          font-weight: 800;
          text-transform: uppercase;
          letter-spacing: 1px;
          box-shadow: 0 4px 20px rgba(108, 117, 125, 0.4);
          border: 2px solid #FFF;
          z-index: 2;
          animation: pulse 2s ease-in-out infinite;
        }

        .free-badge {
          position: absolute;
          top: 12px;
          right: 12px;
          background: linear-gradient(135deg, #00cc88, #00b377);
          color: white;
          padding: 8px 16px;
          border-radius: 20px;
          font-size: 0.75rem;
          font-weight: 800;
          text-transform: uppercase;
          letter-spacing: 1px;
          box-shadow: 0 4px 20px rgba(0, 204, 136, 0.4);
          border: 2px solid #FFF;
          z-index: 2;
        }

        @keyframes pulse {
          0%, 100% { 
            transform: scale(1);
            box-shadow: 0 4px 20px rgba(108, 117, 125, 0.4);
          }
          50% { 
            transform: scale(1.05);
            box-shadow: 0 4px 25px rgba(108, 117, 125, 0.6);
          }
        }

        .video-card:hover:not(.video-unavailable) {
          transform: translateY(-8px);
          box-shadow: 0 8px 30px rgba(0,0,0,0.12);
          border-color: #0066ff;
        }

        .learn-btn {
          background: #0066ff;
          color: white;
          border: none;
          padding: 10px 20px;
          border-radius: 6px;
          font-weight: 600;
          transition: all 0.3s ease;
          width: 100%;
          cursor: pointer;
        }

        .learn-btn:hover:not(.btn-disabled) {
          background: #0052cc;
          transform: translateY(-2px);
        }

        .btn-disabled {
          background: #6c757d !important;
          cursor: not-allowed !important;
          opacity: 0.7;
        }

        .btn-disabled:hover {
          transform: none !important;
          background: #6c757d !important;
        }

        .video-unavailable .card-title,
        .video-unavailable .card-text {
          color: #6c757d;
        }

        /* No Videos State */
        .no-videos {
          padding: 3rem 1rem;
        }

        /* Responsive Design */
        @media (max-width: 768px) {
          .filter-tabs {
            gap: 5px;
          }
          
          .filter-btn {
            padding: 8px 16px;
            font-size: 0.9rem;
          }
          
          .search-input {
            padding: 10px 45px 10px 45px;
          }

          .dropdown-filters {
            gap: 10px;
          }

          .filter-dropdown {
            flex: 1;
            min-width: 150px;
          }
        }

        @media (max-width: 576px) {
          .dropdown-filters {
            flex-direction: column;
          }

          .filter-dropdown {
            width: 100%;
          }
        }
      `}</style>
    </MyProSidebarProvider>
  );
}

export default Video;